import React, { ReactNode } from 'react';
import cx from 'classnames';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import useTransViewCount from '@/hooks/useTransViewCount';
import styles from './index.scss';
import { LabelTag } from '@/components/label-tag-gray-theme';
import {
  LearningType,
  TagInfo,
} from '@/api/seller/serv/oec_seller_learning_center_api';

interface ArticleCardProps {
  className?: string;
  direction?: 'horizontal' | 'vertical';
  poster: ReactNode;
  title: ReactNode;
  desc?: ReactNode;
  views?: number;
  onClick?: () => void;
  isRecommend?: boolean;
  tagInfo?: Array<TagInfo>;
  learningType?: LearningType;
  count?: number;
}

export const ArticleCard = ({
  className,
  direction = 'vertical',
  poster,
  title,
  desc,
  views,
  onClick,
  isRecommend = false,
  tagInfo = [],
  learningType,
  count,
}: ArticleCardProps) => {
  const { t } = useTranslation();
  const isSrc = typeof poster === 'string' && /^https?:\/\/.*/.test(poster);
  // const viewsStr = views ? useTransViewCount(views) : '--';

  return (
    <div
      className={cx(
        styles.ArticleCard,
        {
          [styles.ArticleCardHorizontal]: direction === 'horizontal',
        },
        className,
      )}
      onClick={onClick}
      style={{
        border: isRecommend ? '1px solid #e6e6e6' : '',
        height: isRecommend ? '308px' : '',
      }}>
      <div className={styles.ArticleCardBanner}>
        {isSrc ? (
          <div className={styles.ContentImg}>
            <img src={poster as string} alt={'article banner image'} />
            {learningType === LearningType.Course && (count || 0) > 1 && (
              <p>
                {count} {t('academy_homepage_course_cover_lesson_plural')}
              </p>
            )}
          </div>
        ) : (
          poster
        )}
      </div>
      <div className="flex flex-col p-16">
        <div className={styles.content}>
          {!isRecommend && <LabelTag tagInfo={tagInfo} />}
          <div className={styles.title}>{title}</div>
          <div className={styles.desc}>{desc}</div>
        </div>
        {/* <div className={styles.views}>
          {viewsStr} {t('academy_homepage_content_cover_views')}
        </div> */}
      </div>
    </div>
  );
};
